module.exports = __webpack_public_path__ + "static/img/logozw.eb61922.png";


//////////////////
// WEBPACK FOOTER
// ./static/logozw.png
// module id = Uuq1
// module chunks = 1